import 'reflect-metadata';
import { getPropNames } from '../reflection';
import { IMetricResult } from '../users/biometric';
import {
  AreaCategory, BookingState, RemovedReasonType, WorkoutType, WorkoutSettingsBase,
} from './IUserWorkoutSessionTypes';
import { IWorkoutDates } from './IWorkoutDates';
import { IWorkoutImportContext } from './WorkoutImportConfig';

export function propNamesIUserWorkoutSessionSummary() { return getPropNames<IUserWorkoutSessionSummary>(); }
export interface IUserWorkoutSessionSummary extends IWorkoutDates {
  userProfileId: string;
  workoutType: WorkoutType;
  uniqueReference: string;
  settings: WorkoutSettingsBase;
  startTime: Date;
  startTimeOfFirstExercise: Date;
  endTime: Date;
  bookingState: BookingState;
  performanceMetrics: IMetricResult | null;
  expiresAt?: Date;
  removedAt: Date | false;
  removedReason?: RemovedReasonType;
  overlappedByWorkoutId?: string;
  workoutMarkedAsCompletedAt?: Date | false;
  pairedSessionReference?: string;
  pairedSessionUserProfileId?: string;
  openInviteLink: string;
  importOrigin?: IWorkoutImportContext;
  additionalSecondsBeforeFirstExercise?: number;
  gymName: string;
  checkedIn: boolean;
  areaCategory?: AreaCategory;
}
